export default "__VITE_ASSET__BJ$dRzUa__"